import { createContext, useContext, useEffect } from "react"

type Theme = "light"

type ThemeProviderProps = {
  children: React.ReactNode
  defaultTheme?: string
  storageKey?: string
}

type ThemeProviderState = {
  theme: Theme
  setTheme: (theme: string) => void
}

const initialState: ThemeProviderState = {
  theme: "light",
  setTheme: () => null,
}

const ThemeProviderContext = createContext<ThemeProviderState>(initialState)

// AppAcademia ships a single light theme. The provider stays so existing
// callers of useTheme keep working, but it always applies the light class and
// clears any dark preference left in the browser by earlier versions.
export function ThemeProvider({ children, storageKey = "vite-ui-theme" }: ThemeProviderProps) {
  useEffect(() => {
    const root = window.document.documentElement
    root.classList.remove("dark")
    root.classList.add("light")
    try {
      localStorage.removeItem(storageKey)
      localStorage.removeItem("theme")
    } catch {
      /* storage unavailable */
    }
  }, [storageKey])

  return (
    <ThemeProviderContext.Provider value={initialState}>
      {children}
    </ThemeProviderContext.Provider>
  )
}

export const useTheme = () => useContext(ThemeProviderContext)
